var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRakete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2158_5340)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2158_5340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.953125H24.5V24.9531H0.5V0.953125Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2158_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2071 7.24602C21.5976 7.63654 21.5976 8.26971 21.2071 8.66023L11.2071 18.6602C10.8166 19.0508 10.1834 19.0508 9.79289 18.6602L4.79289 13.6602C4.40237 13.2697 4.40237 12.6365 4.79289 12.246C5.18342 11.8555 5.81658 11.8555 6.20711 12.246L10.5 16.5389L19.7929 7.24602C20.1834 6.85549 20.8166 6.85549 21.2071 7.24602Z",
    fill: "url(#paint0_linear_2158_5340)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2158_5340",
    x1: 4.5,
    y1: 18.9531,
    x2: 23.356,
    y2: 11.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2158_5340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRakete);
export default __webpack_public_path__ + "static/media/check_rakete.6222eca59a84e2edcc26735c0d7739a5.svg";
export { ForwardRef as ReactComponent };